import React from 'react';
import { PlusIcon } from 'lucide-react';
import { CATEGORY_META } from '../utils';

const remainingLabel = (unit) => (unit ? `${unit} remaining` : 'remaining');

const ItemCard = ({ item, onLog, onOpen }) => {
    const isLowStock = item.reorderLevel > 0 && item.currentRemaining <= item.reorderLevel;
    const meta = CATEGORY_META[item.category] || CATEGORY_META.others;

    return (
        <div className="flex flex-col justify-between rounded-2xl border border-inv-cream-200 bg-white p-4 transition-all hover:-translate-y-0.5 hover:shadow-[0_16px_30px_-20px_rgba(40,22,8,0.35)]">
            <div>
                <div className="flex items-start justify-between gap-2">
                    <button onClick={onOpen} className="text-left font-bold text-inv-ink hover:text-inv-brand">{item.name}</button>
                    {isLowStock && (
                        <span className="shrink-0 rounded-full bg-red-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-red-600">Low</span>
                    )}
                </div>
                <span className="mt-1 inline-flex items-center gap-1.5 text-[11px] font-medium text-[#8C8175]">
                    <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: meta.hex }} />
                    {meta.label}
                </span>
            </div>

            <div className="mt-3 flex items-end justify-between">
                <div>
                    <div className="text-2xl font-extrabold leading-none text-inv-ink">{item.currentRemaining}</div>
                    <div className="mt-1 text-xs text-[#8C8175]">{remainingLabel(item.unitOfMeasure)}</div>
                </div>
                <button
                    onClick={onLog}
                    className="flex h-9 w-9 items-center justify-center rounded-xl bg-inv-brand-light text-inv-brand transition-colors hover:bg-inv-brand hover:text-white"
                    aria-label={`Log entry for ${item.name}`}
                >
                    <PlusIcon size={18} />
                </button>
            </div>
        </div>
    );
};

export default ItemCard;
